import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  ImageList,
  ImageListItem,
  GridListTileBar,
  IconButton,
} from "@material-ui/core";
import CheckCircleOutlineRoundedIcon from "@material-ui/icons/CheckCircleOutlineRounded";
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";

// Contexts
import FacebookAdContext from "../../../../context/facebook_profiles/ad/AdContext";

// Components
import Spinner from "../../../layout/SpinnerSmall";

const useStyles = makeStyles((theme) => ({
  root: {
    height: 500,
  },
  grid: {
    height: "auto",
  },
  video: {
    "&:focus": {
      outline: "none",
    },
  },
  load: {
    marginTop: "1rem",
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
}));

const VideoSelection = ({ browserOpen, browserClose, browserSave }) => {
  const classes = useStyles();

  const { browseVideo, videos, video_url, video_next_cursor, browse_loading } =
    useContext(FacebookAdContext);

  const [selectedVideo, setSelectedVideo] = useState("");
  const [selectedFilename, setSelectedFilename] = useState("");

  const onSelect = (url, public_id) => {
    setSelectedVideo(url);
    setSelectedFilename(public_id);
  };

  const onLoadMore = () => {
    browseVideo("more");
  };

  const onSave = () => {
    setSelectedVideo("");
    setSelectedFilename("");
    browserSave(selectedVideo, selectedFilename);
  };

  const onCancel = () => {
    setSelectedVideo("");
    setSelectedFilename("");
    browserClose();
  };

  useEffect(() => {
    if (browserOpen) {
      browseVideo();

      if (videos && video_url) {
        videos.map((video) => {
          if (video.secure_url === video_url) {
            setSelectedVideo(video_url);
            setSelectedFilename(video.public_id);
          }
        });
      }
    }
  }, [browserOpen]);

  return (
    <Dialog
      disableBackdropClick
      fullWidth
      maxWidth="md"
      open={browserOpen}
      onClose={browserClose}
    >
      <DialogTitle> Select video </DialogTitle>
      <DialogContent dividers className={classes.root}>
        <ImageList cols={4} className={classes.grid}>
          {" "}
          {videos && videos.length === 0 && (
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              style={{
                width: "100%",
                height: 435,
              }}
            >
              <Typography variant="body1"> No video found. </Typography>{" "}
            </Grid>
          )}
          {videos &&
            videos.map((video) => {
              return (
                <ImageListItem key={video.public_id}>
                  <video
                    height="120"
                    width="100%"
                    controls
                    muted
                    src={video.secure_url}
                    className={classes.video}
                  />{" "}
                  <GridListTileBar
                    title={video.filename}
                    actionIcon={
                      <IconButton
                        className={classes.button}
                        onClick={() =>
                          onSelect(video.secure_url, video.public_id)
                        }
                      >
                        {selectedVideo === video.secure_url ? (
                          <CheckCircleRoundedIcon color="secondary" />
                        ) : (
                          <CheckCircleOutlineRoundedIcon color="secondary" />
                        )}{" "}
                      </IconButton>
                    }
                  />{" "}
                </ImageListItem>
              );
            })}{" "}
        </ImageList>
        {video_next_cursor && (
          <Grid container justifyContent="center" className={classes.load}>
            {" "}
            {browse_loading ? (
              <Spinner />
            ) : (
              <Button
                variant="outlined"
                color="primary"
                className={classes.button}
                onClick={onLoadMore}
              >
                Load more{" "}
              </Button>
            )}{" "}
          </Grid>
        )}{" "}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={onSave}
          disabled={selectedVideo ? false : true}
        >
          Select{" "}
        </Button>
        <Button
          variant="contained"
          className={classes.button}
          onClick={onCancel}
        >
          Cancel{" "}
        </Button>{" "}
      </DialogActions>{" "}
    </Dialog>
  );
};

export default VideoSelection;
